module.exports = __webpack_public_path__ + "static/media/si.925e1976.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/si.svg
// module id = 245
// module chunks = 0